import { useState } from "react";
import BrandAPIDataSourceImpl from "../../Data/DataSource/API/BrandAPIDataSource";
import { BrandRepositoryImpl } from "../../Data/Repository/BrandRepositoryImpl";
import { Brand } from "../../Domain/Model/Brand";
import { CreateBrand } from "../../Domain/UseCase/CreateBrand";
import { GetBrands } from "../../Domain/UseCase/GetBrands";
import { RemoveBrand } from "../../Domain/UseCase/RemoveBrand";
import { UpdateBrand } from "../../Domain/UseCase/UpdateBrand";

import { ListBoxChangeEvent } from "primereact/listbox";
import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { GetBrandsList } from "../../Domain/UseCase/GetBrandsList";


export default function BrandViewModel() {

    const [brands, setBrands] = useState<Brand[]>([]);
    const [brandsList, setBrandsList] = useState<Brand[]>([]);

    const brandDataSourceImpl = new BrandAPIDataSourceImpl();
    const brandRepositoryImpl = new BrandRepositoryImpl(brandDataSourceImpl);

    const getBrandsUseCase = new GetBrands(brandRepositoryImpl);
    const getBrandsListUseCase = new GetBrandsList(brandRepositoryImpl);
    const createBrandUseCase = new CreateBrand(brandRepositoryImpl);

    const removeBrandUseCase = new RemoveBrand(brandRepositoryImpl);
    const updateBrandUseCase = new UpdateBrand(brandRepositoryImpl);

    async function getBrands(page: number, size: number, search: string): Promise<{ items: Brand[]; totalCount: number }> {
      try {
        const result: PaginationResult<Brand> = await getBrandsUseCase.invoke(page, size, search );
    
        await setBrands(result.items); // Si quieres mantenerlo en el ViewModel
        return {
          items: result.items,
          totalCount: result.totalCount, // usar totalCount según tu interfaz
        };
      } catch (error) {
        console.error("Error al obtener productos:", error);
        return { items: [], totalCount: 0 };
      }

    }

    async function getBrandsList() {
       setBrandsList(await getBrandsListUseCase.invoke());
    }

      async function createBrand(data: Brand) {
        try {
          const createdBrand = await createBrandUseCase.invoke(data);
          if(createdBrand){
            console.log("enviado", createdBrand);
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
        }
      }

      async function removeBrand(id: string) {
        try {
          let removedBrand = await removeBrandUseCase.invoke(id);
          if(removedBrand){
            console.log("eliminado");
           return removedBrand;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
      }

      async function updateBrand(data: Brand) {
        try {
          let updatedBrand = await updateBrandUseCase.invoke(data);
          if(updatedBrand){
            console.log("Actualizado");
           return updatedBrand;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            console.log(e.message);
          }
          return Error;
        }
      }

      function onChangeBrand(e: ListBoxChangeEvent) {
        e.preventDefault();
        setBrands(e.target.value);
      }
      
      return {
        getBrands,
        getBrandsList,
        createBrand,
        removeBrand,
        updateBrand,
        onChangeBrand,
        brands,
        brandsList
      };
}